<template>
  <div class="px-1">
    <div v-if="themeTagNames" data-testid="experience-card-theme-tags" :class="['flex items-center gap-2 overflow-hidden leading-[1.5]', isDarkTheme ? 'text-gold4' : 'text-gold3']">
      <p class="min-w-0 truncate font-DMSans text-[11px] uppercase tracking-[1.65px]">{{ themeTagNames }}</p>
      <span aria-hidden="true" class="shrink-0 whitespace-nowrap text-[12px] font-light">────</span>
    </div>
    <!-- TODO: font-sizeは、tailwind.config.jsにてクラスを定義後そちらを使用し、px指定しないようにする -->
    <p :class="['mt-1 line-clamp-3 leading-5 tracking-tight md:text-[17px] md:leading-7', isDarkTheme ? 'text-white md:group-hover:text-gold4' : 'text-gray9 md:group-hover:text-gold3']">
      {{ experience.name }}
    </p>
    <div :class="['mt-1 flex items-center justify-between text-sm md:text-base', isDarkTheme ? 'text-gray8' : 'text-gray4']">
      <div class="flex flex-wrap items-center text-left tracking-normal">
        <p>{{ destinationTagName }}</p>
        <!-- TODO: font-sizeは、tailwind.config.jsにてクラスを定義後そちらを使用し、px指定しないようにする -->
        <span class="px-1 text-[14px]">|</span>
        <img v-if="isDarkTheme" class="my-auto h-4 w-4 -translate-y-px md:h-5 md:w-5" src="@/assets/icon/wabunka/clock-gray300.svg" />
        <img v-else class="my-auto h-4 w-4 -translate-y-px md:h-5 md:w-5" src="@/assets/icon/wabunka/clock-gray500.svg" />
        <!-- TODO: font-sizeは、tailwind.config.jsにてクラスを定義後そちらを使用し、px指定しないようにする -->
        <p class="tracking-normal md:block">
          {{ experience.experienceDuration?.value }}<span class="text-[11px] md:text-[14px]">{{ experience.experienceDuration?.unit }}</span>
        </p>
        <template v-if="formattedPrice">
          <!-- TODO: font-sizeは、tailwind.config.jsにてクラスを定義後そちらを使用し、px指定しないようにする -->
          <span class="px-1 text-[14px]">|</span>
          <!-- TODO: font-sizeは、tailwind.config.jsにてクラスを定義後そちらを使用し、px指定しないようにする -->
          <p class="tracking-normal">
            {{ formattedPrice }}
          </p>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { displayPrice, type ExperienceViewModel } from '@/wabunka-src/features/Experience';
import { displayDestinationTagName, extractDisplayThemeTags } from '@/wabunka-src/features/Experience/models/wabunkaExperienceTag';

interface Props {
  experience: ExperienceViewModel;
  // テーマを指定
  theme: 'light' | 'dark';
}

const props = withDefaults(defineProps<Props>(), {
  theme: 'light',
});

const isDarkTheme = computed(() => props.theme === 'dark');
const destinationTagName = computed(() => {
  return displayDestinationTagName(props.experience.tags);
});

const formattedPrice = computed(() => {
  return displayPrice(props.experience);
});

const themeTagNames = computed(() => {
  const tags = extractDisplayThemeTags(props.experience.tags);
  return tags.map((t) => t.name).join(', ');
});
</script>
